import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-163c9c0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "fee-table" }
const _hoisted_3 = { class: "el-dialog__body-footer flex-center" }

import { t } from '@/plugins/i18n'

import STable from '@/components/Table/index.vue'
import { getBillingFeeDetails } from '@/apis/order'
import { useRtfix } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowItem: {
    type: Object,
    default: () => ({})
  }
},
  emits: ['update:visible'],
  setup(__props, { emit: emits }) {




const feeColumns:any = [
  {
    label: t('费用名称'),
    prop: 'feeName',
    align: 'center'
  },
  // {
  //   label: t('数量'),
  //   prop: 'quantity',
  //   align: 'center'
  // },
  {
    label: t('结算总价（元）'),
    prop: 'totalSettlementPrice',
    align: 'center'
  }
]
const apiConfig = {
  listPath: 'data'
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "destroy-on-close": "",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emits('update:visible', false))),
    draggable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('详情')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(STable, {
          api: _unref(getBillingFeeDetails),
          "filter-data": { platformOrderId: __props.rowItem.platformOrderId },
          "api-config": apiConfig,
          columns: feeColumns,
          "show-pagination": false
        }, null, 8, ["api", "filter-data"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('update:visible', false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('我知道了')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('StoreFund',  { query: { platformOrderNo: __props.rowItem.platformOrderNo }}))))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('结算中心查看明细')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})